import React from "react";
import PlacementPageSectoin from "../../Sections/PlacementPageSection/Content";
const PlacementPage = () => {
  return <PlacementPageSectoin />;
};

export default PlacementPage;
